export default __webpack_public_path__ + "static/media/Ballroll_00125.64054a54.png";